import { ImageProps } from 'next/image'

import { SImage } from '../../rest/types/api/Image'
import { api } from '../../configuration'
import { Image } from '../../rest/types/Image'
import { getSize, toBase64 } from '../../helpers/FileHelpers'

export function ImageTransformer(
  data?: SImage | null,
  fill = false,
  useBaseUrl = false
): ImageProps | undefined {
  if (!data) return undefined

  const format = data.formats?.large?.url
    ? data.formats.large
    : data.formats?.medium?.url
    ? data.formats.medium
    : data.formats?.small?.url
    ? data.formats.small
    : data.formats?.thumbnail?.url
    ? data.formats.thumbnail
    : undefined

  return {
    src: `${api.API_URL}${useBaseUrl ? data.url : format?.url || data.url}`,
    alt: data.alternativeText ?? '',
    ...(!fill && {
      width: format?.width || data.width,
      height: format?.height || data.height,
    }),
    fill,
  }
}

export const UrlImageTransformer = (url: string) => {
  return `${api.API_URL}${url}`
}

export const ImageToFile = (image: SImage | null | undefined): File => {
  return new File([''], image?.name ?? '')
}

export function UrlTransformer(image: Image) {
  return api.API_URL + '/' + image.url
}

export async function FileToImage(file: File): Promise<Image> {
  const base64 = await toBase64(file)
  const { width, height } = await getSize(file)

  return {
    url: base64,
    caption: '',
    width: width,
    height: height,
    formats: {},
    id: '',
  }
}
